import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export interface PortalChallengeContext {
  email: string;
  otpExpiresAtEpochMs: number;
  resendAvailableAtEpochMs: number;
}

const CHALLENGE_KEY = 'portal.challenge-context';
const PERSIST_LOGIN_KEY = 'portal.persist-login';

@Injectable({ providedIn: 'root' })
export class PortalAuthFlowService {
  private readonly platformId = inject(PLATFORM_ID);

  setChallengeContext(ctx: {
    email: string;
    otpExpiresInSeconds: number;
    resendAvailableInSeconds: number;
  }): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const now = Date.now();
    const stored: PortalChallengeContext = {
      email: ctx.email,
      otpExpiresAtEpochMs: now + ctx.otpExpiresInSeconds * 1000,
      resendAvailableAtEpochMs: now + ctx.resendAvailableInSeconds * 1000,
    };
    sessionStorage.setItem(CHALLENGE_KEY, JSON.stringify(stored));
  }

  getChallengeContext(): PortalChallengeContext | null {
    if (!isPlatformBrowser(this.platformId)) return null;
    const raw = sessionStorage.getItem(CHALLENGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as PortalChallengeContext;
    } catch {
      return null;
    }
  }

  clearChallengeContext(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    sessionStorage.removeItem(CHALLENGE_KEY);
  }

  setPersistLogin(value: boolean): void {
    if (!isPlatformBrowser(this.platformId)) return;
    sessionStorage.setItem(PERSIST_LOGIN_KEY, String(value));
  }

  shouldPersistLogin(): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    return sessionStorage.getItem(PERSIST_LOGIN_KEY) === 'true';
  }

  clearPersistLogin(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    sessionStorage.removeItem(PERSIST_LOGIN_KEY);
  }
}
